function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'))
    return match ? match[1] : ''
}

// eslint-disable-next-line no-async-promise-executor
const uploader = (blobInfo, type) => new Promise(async (resolve, reject) => {
    try {
        const form = new FormData()
        form.append('file', blobInfo.blob(), blobInfo.filename())

        const xsrfFromCookie = decodeURIComponent(getCookie('XSRF-TOKEN') || '')

        const endpoint = type === 'image' ? '/api/upload/image' : '/api/upload/video'
        const res = await fetch(`${import.meta.env.VITE_APP_API_URL}${endpoint}`, {
            method: 'POST',
            body: form,
            credentials: 'include',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-XSRF-TOKEN': xsrfFromCookie
            }
        })

        if (!res.ok) {
            const text = await res.text().catch(() => '')
            return reject(`Upload failed (${res.status}): ${text || res.statusText}`)
        }

        const json = await res.json()
        if (!json || !json.location) {
            return reject('Upload response must be JSON with a "location" field.')
        }

        resolve(json.location)
    } catch (err) {
        reject('Upload error: ' + (err?.message || String(err)))
    }
})

export const image_uploader = (blobInfo) => uploader(blobInfo, 'image')
export const video_uploader = (blobInfo) => uploader(blobInfo, 'video')